<template>
<div class="user-product">
  <p>已购的产品<span v-if="total > 0">（共<i>{{total}}</i>条记录）</span></p>
  <Tabs v-model="tab_name" :animated="false">
    <TabPane label="购买的专题" name="theme">
      <UserTheme @themeTotal="themeTotal"></UserTheme>
    </TabPane>
    <TabPane label="购买的报告" name="report">
      <UserReport @reportTotal="reportTotal" :meta="meta"></UserReport>
    </TabPane>
  </Tabs>
</div>
</template>
<script>
import { get_meta } from 'js/get_meta'
import UserReport from './components/UserReport.vue'
import UserTheme from './components/UserTheme.vue'
import { getAddPuv } from 'js/addPuv.js'
export default {
  mixins: [ get_meta,getAddPuv ],
  components: { UserReport, UserTheme },
  data() {
    return {
      tab_name: 'theme',
      theme_total: 0,
      report_total: 0
    }
  },
  computed: {
    user_key() {
      return this.$store.state.user_key
    },
    total() {
      return this.tab_name == 'theme' ? this.theme_total : this.report_total
    }
  },
  methods: {
    themeTotal(val) {
      this.theme_total = val
    },
    reportTotal(val) {
      this.report_total = val
    }
  },
  created() {
    this.getMeta(['report_type'])
    let url = window.location.href
    this.getAddPuv(url)
  }
}
</script>
<style lang="stylus" scoped>
@import '~styles/common.stylus'
.user-product
  width: 1200px
  margin: 0 auto
  padding: 30px 0 20px
  > p
    margin-bottom: 20px
    commonColor(#FFFFFF, #333333)
    font-size: 18px
    font-weight: 500
    span
      commonColor(#BCBDC1, #999999)
      font-size: 14px
      i
        color: rgba(250, 122, 80, 1)
        font-style: normal
  >>>.ivu-tabs-nav-scroll
    commonBgColor(#2A2F42, #FFFAF5)
    .ivu-tabs-tab
      width: 200px;
      commonColor( #BCBDC1, #999)
      text-align: center;
      padding: 15px 16px;
      &.ivu-tabs-tab-active
        commonBgColor(#1F2330, #ffffff);
        commonColor(#fff, #333);
    .ivu-tabs-ink-bar
      top: 1px;
      background-color: rgba(250, 122, 80, 1)
  >>>.ivu-tabs-bar
    margin-bottom: 0;
  >>>.ivu-tabs-content
    commonBgColor(#1F2330, #fff)
</style>
